<template>
  <div>

      <van-sticky>
        <van-nav-bar :title="fad">
          <template #left><van-icon @click="onBack" name="arrow-left" /></template>
          <template #right><van-icon name="bullhorn-o" badge="0"/></template>
        </van-nav-bar>
      </van-sticky>

    <router-view/>


  </div>
</template>

<script>
import { decode } from 'js-base64';
export default {
  name: 'app',
    data() {
      return {
            fad:decode(this.$request.ayar().genel.f),
            isim:decode(this.$request.ayar().genel.k),
      };
  },
  created(){
    //this.active = this.$route.name
    //alert("drg")
  },
  methods: {
    onBack() {
     window.history.back();
    //this.$route.go("/hesap")
    },
      // cikis(){
      //     this.$helper.logout();
      // },    
  }  
 
}
</script>



// WEBPACK FOOTER //
// src/components/content.vue